// removed by extract-text-webpack-plugin
module.exports = {"PlaceholderDefaultColor":"#d8d8d8","PlaceholderDarkGrey":"#8e8e8e","Content":"Content-fk1cpa2gyerjmgf9644aq929zcd2z2s7ds7ktv5p11vuug9yk373np96tn7kbwp1w93rqe1mqyq29x89jkxr1c1d5j9y92dfgwst23","loading":"loading-3qykuqnea3sceydyx6vnarft6s5mpke5jceq7qxawgbpu6d6715rqv13f2fhkj1sr7u6v4m3j7qx4ne2y1bqrwvq6sj1veep214g5sz","pulse":"pulse-26prxf2qrtpwran9pdcpcv4kwxwc77m8p2pjh9gpngzdys8maxqq1fagcmtyhmtfberht6p93vxt9fwg4dge4h1mxxnxykj4ra4d65z"};


//////////////////
// WEBPACK FOOTER
// ./src/views/TermsOfUse/TermsOfUse.module.scss
// module id = 1713
// module chunks = 0